<app-header></app-header>
<ion-content
  id="product-usage-page"
  class="gray-content-bg"
  [ngClass]="platformClass"
>
  <div class="page-content-wrapper">
    <ng-container *ngIf="isDesktop">
      <div class="header-wrapper">
        <app-breadcrumb activePageName="Product Usage"></app-breadcrumb>
        <ion-row class="title-row">
          <ion-col>
            <h1 class="page-title">PRODUCT USAGE</h1>
          </ion-col>
          <app-date-range-section
            [filterDateRange]="deliveryDateRange$ | async"
            (changeDateFilterClicked)="openModal(true)"
          ></app-date-range-section>
        </ion-row>
      </div>
      <div class="filter-header-container">
        <ion-row class="filtering-banner-container">
          <div class="action-bar">
            <button class="action-btn underline" type="button">
              Customize columns
            </button>
            <span class="divider" aria-hidden="true"></span>
            <button
              class="action-btn download-btn"
              type="button"
              (click)="toggleMenu()"
              [class.active]="submenuOpen"
            >
              <span class="underline">Download</span>
              <ion-icon name="download-outline" slot="end"></ion-icon>
            </button>
          </div>
          <ng-container *ngIf="submenuOpen">
            <div class="overlay" (click)="submenuOpen = false"></div>
            <div class="download-menu">
              <svg class="arrow" viewBox="0 0 17 7.881" aria-hidden="true">
                <path d="M0 7.881 L8.5 0 L17 7.881 Z" fill="#56821F" />
              </svg>
              <button class="menu-item" (click)="selectReport()">
                Full report
              </button>
              <button class="menu-item">Custom report</button>
            </div>
          </ng-container>
          <app-filter-section
            [numberOfSelectedFilters]="numberSelectedFilters$ | async"
            (filterClicked)="openModal()"
          ></app-filter-section>
        </ion-row>
      </div>
    </ng-container>

    <div class="filter-header-container" *ngIf="isTouch">
      <ion-grid fixed="true">
        <ion-row class="filtering-banner-container">
          <ng-container *ngIf="isTablet">
            <app-date-range-section
              [filterDateRange]="deliveryDateRange$ | async"
              (changeDateFilterClicked)="openModal(true)"
            ></app-date-range-section>
          </ng-container>

          <app-usf-filtering-banner-mobile
            *ngIf="isMobile"
            [isLoading]="false"
            [showQuickDateFilterOption]="true"
            [numberOfSelectedFilters]="numberSelectedFilters$ | async"
            (filterClicked)="openModal()"
            (changeDateFilterClicked)="openModal(true)"
            (resetFiltersClicked)="resetFilters()"
            [showResetFilterOption]="false"
            [filterDateRange]="deliveryDateRange$ | async"
            [resetLabel]="false"
            [showDateRange]="true"
          >
          </app-usf-filtering-banner-mobile>
        </ion-row>
        <ion-row class="filter-section-container">
          <div class="action-bar">
            <button class="action-btn underline" type="button">
              Customize columns
            </button>
            <span class="divider" aria-hidden="true"></span>
            <button
              class="action-btn download-btn"
              type="button"
              (click)="toggleMenu()"
              [class.active]="submenuOpen"
            >
              <span class="underline">Download</span>
              <ion-icon name="download-outline" slot="end"></ion-icon>
            </button>
          </div>
          <ng-container *ngIf="submenuOpen">
            <div class="overlay" (click)="submenuOpen = false"></div>
            <div class="download-menu">
              <svg class="arrow" viewBox="0 0 17 7.881" aria-hidden="true">
                <path d="M0 7.881 L8.5 0 L17 7.881 Z" fill="#56821F" />
              </svg>
              <button class="menu-item" (click)="selectReport()">
                Full report
              </button>
              <button class="menu-item">Custom report</button>
            </div>
          </ng-container>
          <app-filter-section
            *ngIf="isTablet"
            [numberOfSelectedFilters]="numberSelectedFilters$ | async"
            (filterClicked)="openModal()"
          ></app-filter-section>
        </ion-row>
      </ion-grid>
    </div>

    <div class="content-container">
      <div class="error-toast-container">
        <app-report-toast-container></app-report-toast-container>
      </div>
      <ion-grid fixed="true">
        <ion-row class="toast-container" *ngIf="isTouch">
          <ion-col>
            <app-data-usage-warning></app-data-usage-warning>
          </ion-col>
        </ion-row>
      </ion-grid>
      <div *ngIf="(isTableLoading$ | async) || showSkeleton; else tableContent">
        <div class="table-skeleton-container">
          <ion-skeleton-text
            *ngFor="let bar of [1,2,3,4,5,6,7,8,9,10,11,12]"
            class="row-skeleton"
            animated
          ></ion-skeleton-text>
        </div>
      </div>
      <ng-template #tableContent>
        <div class="no-data-container" *ngIf="noData">
          <h2 class="no-data-title">There is no data to show</h2>
          <p class="no-data-label">
            Please adjust your
            <span class="no-data-label-link" (click)="openModal()">filters</span
            >.
          </p>
        </div>
        <app-report-table
          [dataSource]="dataSource"
          [columnsToDisplay]="columnsToDisplay"
          *ngIf="!noData"
        ></app-report-table>
      </ng-template>
    </div>
  </div>
  <app-footer></app-footer>
</ion-content>
